import React from "react";
import Modal from "./Modal";
import Slideshow from "../Slideshow";
import { useDispatch } from "react-redux";
import { openPopup } from "../../reducers/popup";

const ModalIntroAds = () => {
  const dispatch = useDispatch();

  const handleCloseClick = () => {
    dispatch(openPopup({}));
  };

  return (
    <Modal>
      <div className="relative z-20 mx-auto">
        <Slideshow onCloseClick={handleCloseClick} />
      </div>
    </Modal>
  );
};

export default React.memo(ModalIntroAds);
